export const Skills = (
  <div>
    Currently learning:
    <ul>
      <li>- Python</li>
      <li>- ReactJS</li>
      <li>- Egyptian</li>
    </ul>
    <br />I have experience with:
    <div className="grid grid-cols-4 place-items-start text-sm sm:text-lg">
      <div className="col-span-2">- HTML & CSS</div>
      <div className="col-span-2">- MySQL</div>
      <div className="col-span-2">- C#</div>
      <div className="col-span-2">- Javascript</div>
      <div className="col-span-2">- ReactJS</div>
      <div className="col-span-2">- Python</div>
      <div className="col-span-2">- Bash</div>
      <div className="col-span-2">- YAML</div>
    </div>
    <br />
    Languages I'm familiar with:
    <ul>
      <li>- Dutch</li>
      <li>- English</li>
      <li>- Arabic (MSA, Egyptian)</li>
    </ul>
  </div>
);
export default Skills;
